module.exports = __webpack_public_path__ + "static/media/10.962c6137.jpeg";